export const ASYNC_RESPONSE_CODE = 202



// WEBPACK FOOTER //
// ./app/sagas/constants.js